export default "__VITE_ASSET__8e1ca6dc__"